
export const notificationEndpoints = {
    getNotificationList: '/notification/notifications-list/',
    postNotificationViewed: '/notification/notification-viewed/',
    
};